import Reflux from "reflux";
const FooterActions: any = Reflux.createActions(["updateFooter", "standardFooterLayout"]);
export default FooterActions;
